module.exports = __webpack_public_path__ + "static/img/open.93b1b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/open.png
// module id = 8r3S
// module chunks = 12